const date = {
    format : "dd.MM.yyyy, HH:mm:ss",
    locale : "he-IL"
};


export default date;